// src/utils/generateExcelStats.js
// Build an Excel file for attendance stats using 'xlsx'.

import * as XLSX from 'xlsx';

/**
 * Create Excel for stats and return either Blob (returnBlob) or download it client-side.
 * @param {Object} options
 * @param {Array} options.rows [{ n, cognome, nome, photoURL, presenze, totIncontri, percentuale }]
 * @param {String} options.asOfDateLabel
 * @param {String} options.yearLabel  // <— NUOVO
 * @param {Boolean} options.returnBlob when true, returns { xlsxBlob }
 */
export async function generateExcelStats({ rows = [], asOfDateLabel = '', yearLabel = '', returnBlob = false }) {
  const wsData = [
    ['#', 'Cognome', 'Nome', 'Foto', 'Presenze', 'Tot Incontri', 'Percentuale', `Fino al: ${asOfDateLabel}`, ...(yearLabel ? [`Anno: ${yearLabel}`] : [])],
    ...rows.map((r) => [
      r.n, r.cognome, r.nome, r.photoURL || '', r.presenze, r.totIncontri, `${r.percentuale}%`,
    ]),
  ];
  // Statistiche globali delle presenze (calcolate sulle righe)
  const percentValues = (rows || [])
    .map((r) => {
      if (typeof r.percentuale === 'number') return r.percentuale;
      const raw = String(r.percentuale ?? '').replace('%', '').replace(',', '.').trim();
      const v = parseFloat(raw);
      return Number.isFinite(v) ? v : null;
    })
    .filter((v) => v !== null);

  let avgPresencePerc = 0;
  let highPresenceCount = 0;
  let lowPresenceCount = 0;

  if (percentValues.length) {
    const sum = percentValues.reduce((acc, v) => acc + v, 0);
    avgPresencePerc = Math.round(sum / percentValues.length);
    highPresenceCount = percentValues.filter((v) => v >= 80).length;
    lowPresenceCount = percentValues.filter((v) => v < 50).length;
  }

  if (rows.length) {
    wsData.push([]);
    wsData.push(['', 'Media presenze studenti', '', '', '', '', `${avgPresencePerc}%`]);
    wsData.push(['', 'Studenti con presenze ≥ 80%', '', '', '', '', highPresenceCount]);
    wsData.push(['', 'Studenti con presenze < 50%', '', '', '', '', lowPresenceCount]);
  }



  const ws = XLSX.utils.aoa_to_sheet(wsData);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Statistiche');

  // Autosize cols (simple heuristic)
  const colWidths = wsData[0].map((_, i) => ({
    wch: Math.max(...wsData.map(row => String(row[i] ?? '').length), 10)
  }));
  ws['!cols'] = colWidths;

  const ab = XLSX.write(wb, { type: 'array', bookType: 'xlsx' });
  const blob = new Blob([ab], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

  const suggestedName = `Statistiche_${(yearLabel || '').replace(/[\\/:*?"<>|]+/g, '-')}__${asOfDateLabel.replace(/\//g, '-')}.xlsx`;

  if (returnBlob) {
    return { xlsxBlob: blob, suggestedName };
  }

  // client-side download (fallback)
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = suggestedName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return { xlsxBlob: blob, suggestedName };
}
